let voices = []; // Global variable to store available voices
let isPaused = false; // Global flag for pause state
// let isSpeaking = false; // ← NEW: track ElevenLabs playback status
// === Initialize Audio Context (Global) ===
let audioContext = null;

export const speechStatus = {
    isSpeaking: false
};

export const playbackControl = {
    shouldStop: false // If true, prevent new playback
};

export const soundStatus = {
    isPlaying: false
};

// Array of phase titles
const phases = [
    "INTRODUCTION", "FLOW RHYTHM", "RESOURCE STATE I", "DECOMPRESSION RHYTHM",
    "RESOURCE STATE II", "FREEZING", "DECOMPRESSION PROCESS", "RESOURCE STATE II",
    "RESOURCE RHYTM", "RESOURCE STATE I", "RESOURCE STATE II", "RESOURCE-RHYTHM AND REENTERING INTO HERE AND NOW",
    "CLOSING STATEMENT", "CONCLUSION"
];


// export function isMobileDevice() {
//    return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
// }

window.addEventListener('load', () => {
  document.body.style.visibility = 'visible';
});

// === SET AND USE --vw BASED ON VISUAL VIEWPORT ===
export function setRealVW() {
  const vw = window.visualViewport?.width || window.innerWidth;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
  console.log(`✅ setRealVW() → --vw set to ${vw}px`);
}

export function setRealVH() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

window.addEventListener('resize', setRealVH);
window.addEventListener('orientationchange', setRealVH);
setRealVH(); // Run once on load

export async function waitUntilResumed() {
    while (playbackControl.shouldStop) {
        console.log("⏸️ Holding playback...");
        await new Promise((resolve) => setTimeout(resolve, 200));
    }
}

export function nudgeLayout() {
  document.body.style.overflow = 'hidden';
  requestAnimationFrame(() => {
    document.body.style.overflow = '';
  });

  // Bonus: tiny scroll nudge to trigger viewport correction
  window.scrollBy(0, 1);
  window.scrollBy(0, -1);
}


// === FORCE REPAINT TO FIX SAFARI RENDER GLITCHES ===
export function forceRepaintElements() {
  const selectors = [
    '#submitButton',
    '.close-phase-overlay',
    '.header-mobile-container',
    'h1.header-mobile',
    'h2.header-mobile'
    // Add more if needed
  ];
  const elements = document.querySelectorAll(selectors.join(', '));
  console.log(`🔁 Repainting ${elements.length} element(s)...`);

  elements.forEach((el, i) => {
    el.style.display = 'none';
    void el.offsetHeight; // Force reflow
    el.style.display = '';
    console.log(`🔁 Repainted: [${i + 1}/${elements.length}]`, el);
  });

  // Tiny scroll to enforce layout flush (iOS fix)
  window.scrollBy(0, 1);
  window.scrollBy(0, -1);
}

// === DEBUG TOOL: FIND ELEMENTS STUCK AT 390PX ===
export function logElementsWithRealVW100() {
  const elements = document.querySelectorAll('*');
  const problems = [];

  elements.forEach(el => {
    const style = getComputedStyle(el);
    const w = style.width;
    const mw = style.maxWidth;

    if (w === '390px' || mw === '390px') {
      problems.push({
        tag: el.tagName,
        class: el.className,
        id: el.id,
        width: w,
        maxWidth: mw
      });
    }
  });

  console.log(`⚠️ Detected ${problems.length} suspicious element(s)`);
  console.table(problems);
}

export function scrollInstructionsBoxToBottom() {
  const scrollable = document.querySelector('.instructions-scrollable');
  requestAnimationFrame(() => {
    scrollable.scrollTop = scrollable.scrollHeight;
  });
}

// === EVENT: KEYBOARD OPENS — UPDATE vw + REPAINT ===
document.addEventListener('DOMContentLoaded', () => {
  const feedbackInput = document.getElementById('feedbackInput');
  if (feedbackInput) {
    feedbackInput.addEventListener('focus', () => {
      setTimeout(() => {
        setRealVW();
        forceRepaintElements();
        logElementsWithRealVW100();
        // nudgeLayout();
      }, 300); // Delay to let visual viewport stabilize
    });
  }
});

// === GLOBAL INITIALIZATION ON LOAD/RESIZE ===
function handleViewportChange() {
  setRealVW();
  forceRepaintElements();
}

window.addEventListener('load', handleViewportChange);
window.addEventListener('resize', handleViewportChange);

if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', handleViewportChange);
}

// Initial trigger
handleViewportChange();

//+++++++++++++++++++++++++++++++++++++++++++++++++++++

function adjustLayoutToKeyboard() {
  const vw = window.visualViewport.width;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
  
  console.log(`👀 Adjusted --vw to ${vw}px due to keyboard.`);

  // Update inputs or any elements using realVW
  const affectedElements = document.querySelectorAll('#feedbackInput, .questions-box, .main-content');
  affectedElements.forEach(el => {
    el.style.maxWidth = `${vw}px`;
    el.style.width = '100%';
  });
}

if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', () => {
    adjustLayoutToKeyboard();
  });
}

// ++++++++++++++++++++++++++++++++++++++++++++++++++++

export function isMobileDevice() {
  return window.matchMedia("(max-width: 768px)").matches;
}

export function showQuestionsBoxMobilZaubere() {
  const questionsBox = document.querySelector('.questions-box');
  // Add the "show" class, which slides the box up
  questionsBox.classList.add('show');
}

export function showQuestionsBoxMobile() {
    const questionsBox = document.getElementById('questionsBox');
    if (questionsBox) {
        const instructionsDiv = document.getElementById('instructions');
        if (instructionsDiv) {
            instructionsDiv.style.opacity = '0'; // Start fade-out

            setTimeout(() => {
                instructionsDiv.innerHTML = '';     // Clear after fade-out
                instructionsDiv.style.opacity = '1'; // Restore visibility
                console.log("📭 Instructions cleared before slide-in.");
            }, 300); // Duration matches your visual timing
        }

        questionsBox.classList.add('show');
    }
}


let firstHide = true; // Track the first hiding event

export function hideQuestionsBoxMobile() {
    const questionsBox = document.getElementById('questionsBox');
    if (questionsBox) {
        questionsBox.classList.remove('show');
    }
}

export function hideQuestionsBoxMobileZauber() {
    const questionsBox = document.querySelector('.questions-box');

    if (firstHide) {
        // Immediate hide on first call
        questionsBox.style.display = "none"; // Ensures it's not visible at all
        firstHide = false; // Set to false so subsequent calls animate
    } else {
        // Slide out smoothly on subsequent calls
        questionsBox.classList.remove('show'); // This triggers transform: translateY(100%)
    }
}


// export function hideQuestionsBoxMobile() {
//   const questionsBox = document.querySelector('.questions-box');
//   questionsBox.classList.remove('show');
// }

export function logToScreen(message) {
    let logDiv = document.getElementById("log");
    if (!logDiv) {
        logDiv = document.createElement("div");
        logDiv.id = "log";
        logDiv.style = "position:fixed;bottom:0;left:0;width:100%;height:150px;background:white;overflow:auto;font-size:14px;z-index:9999;padding:10px;border-top:1px solid black;";
        document.body.appendChild(logDiv);
    }
    logDiv.innerHTML += `<div>${message}</div>`;
}


function unlockAudio() {
    const unlock = new Audio();
    unlock.src = "data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEARKwAABCxAgAEABAAZGF0YQAAAAA="; // Silent WAV
    unlock.play()
        // .then(() => logToScreen("Unlock audio success!"))
        // .catch(e => logToScreen("Unlock audio failed: " + e.message));
        .then(() => console.log("Unlock audio success!"))
        .catch(e => console.log("Unlock audio failed: " + e.message));
}

export function initializeAudioContext() {
    if (!audioContext) {
        audioContext = new (window.AudioContext || window.webkitAudioContext)();
        // logToScreen("AudioContext created.");
        console.log("AudioContext created.");
    }
    if (audioContext.state === "suspended") {
        // audioContext.resume().then(() => logToScreen("AudioContext resumed."));
        audioContext.resume().then(() => console.log("AudioContext resumed."));
    }
}


// === Function to Play Audio Using AudioContext ===
export async function playAudioBlob(audioBlob) {
    return new Promise(async (resolve, reject) => {
        try {

            const arrayBuffer = await audioBlob.arrayBuffer();
            const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

            const source = audioContext.createBufferSource();
            source.buffer = audioBuffer;
            source.connect(audioContext.destination);

            // source.onended = () => resolve();
            source.onended = () => {
                console.log("Audio playback finished.");
                // logToScreen("Audio playback finished.");
                resolve();
            };
            
            source.start(0);
            console.log("Audio playback started.");
            // logToScreen("Audio playback started.");
        } catch (error) {
            console.log("Error during playback: " + error.message);
            // logToScreen("Error during playback: " + error.message);
            reject(error);
        }
    });
}

function populatePhaseColumn() {
    const phaseColumn = document.getElementById('phaseColumn');
    phases.forEach((phase, index) => {
        const row = document.createElement('div');
        row.classList.add('phase-row');
        row.textContent = phase;
        row.dataset.phaseIndex = index;
        phaseColumn.appendChild(row);
    });
}


function activatePhase(phaseIndex) {
    // Handle desktop phase rows inside #phaseColumn
    document.querySelectorAll('#phaseColumn .phase-row').forEach(row => row.classList.remove('active'));
    const activeRow = document.querySelector(`#phaseColumn .phase-row[data-phase-index="${phaseIndex}"]`);
    if (activeRow) {
        activeRow.classList.add('active');
    }

    // Handle overlay phase rows inside #phaseList
    document.querySelectorAll('#phaseList .phase-row').forEach(row => row.classList.remove('active'));
    const activeOverlayRow = document.querySelector(`#phaseList .phase-row[data-phase-index="${phaseIndex}"]`);
    if (activeOverlayRow) {
        activeOverlayRow.classList.add('active');
        console.log("✅ Activated phase in overlay:", activeOverlayRow);
    } else {
        console.log(`x No matching overlay row found for index ${phaseIndex}`);
    }
}


// Call this function once to populate the phase column on load
document.addEventListener('DOMContentLoaded', populatePhaseColumn);


// Example call to activate the phase, can be called within getNextPhase or displayInstructions
activatePhase(0); // Set initial phase as active


    // Function to clear feedback and recommendation sections
    function clearFeedbackAndRecommendationZauber() {
        document.getElementById('feedbackInput').value = ''; // Clear feedback input
        document.getElementById('recommendation').innerText = ''; // Clear recommendation display
    }


// Clear feedback and recommendation, plus hide the old questions box on mobile at phase transitions
function clearFeedbackAndRecommendation() {
    document.getElementById('feedbackInput').value = '';
    document.getElementById('recommendation').textContent = '';
    document.getElementById('feedbackBox').style.display = 'none';

    // Conditionally hide the questions box only on mobile
    if (isMobileDevice()) {
        hideQuestionsBoxMobile();
    } else {
        // Desktop stays unchanged
        const questionsBox = document.getElementById('questionsBox');
        questionsBox.style.display = 'none';
    }
}


    // Function to clear the radio buttons and feedback box immediately after selection
    function clearFeedbackAndRadioButtons() {
        document.getElementById('feedbackBox').style.display = 'none';  // Hide feedback box
        document.getElementById('questions').style.display = 'none';    // Hide radio buttons
        document.getElementById('questions').innerHTML = '';            // Clear radio buttons content
    }


    function stopSpeech() {
        if (window.speechSynthesis.speaking || window.speechSynthesis.pending) {
            window.speechSynthesis.cancel();
        }
    }



// Dummy function for testing that does nothing
function speakText(text, voiceName = 'Aaron') {
    // Intentionally left blank to bypass voice output
}


function speakTextAfterVoicesLoaded(text, voiceName = 'Aaron') {
    console.log("Opening function speakTextAfterVoicesLoaded:", text);
    if (typeof text !== 'string') {
        console.log("Non-string input detected in speakTextAfterVoicesLoaded:", text);
        return;  // Exit if the input is not a string
    }

    // Wait for voices to load if they haven't yet
    if (voices.length === 0) {
        setTimeout(() => speakTextAfterVoicesLoaded(text, voiceName), 100);
    } else {
        speakTextUnified(text, voiceName);  // Pass both text and voiceName to speakText
    }
}


function scrollToBottom() {
    let box = document.querySelector('.instructions-box');
    if (box) {
        requestAnimationFrame(() => {
            box.scrollTop = box.scrollHeight;
            console.log("🔽 Forced Scroll:", box.scrollTop, "/", box.scrollHeight);
        });
    }
}

function typeText(element, html, letterDelay) {
    return new Promise((resolve) => {
        let currentIndex = 0;
        let box = document.querySelector('.instructions-box');

        function typeNextLetter() {
            if (currentIndex < html.length) {
                if (html[currentIndex] === '<') {
                    const closingTagIndex = html.indexOf('>', currentIndex) + 1;
                    element.innerHTML += html.slice(currentIndex, closingTagIndex);
                    currentIndex = closingTagIndex;
                } else {
                    element.innerHTML += html[currentIndex];
                    currentIndex++;
                }

                // Call scrolling function to keep text in view
                requestAnimationFrame(scrollToBottom);

                setTimeout(typeNextLetter, letterDelay);
            } else {
                resolve();
            }
        }

        typeNextLetter();
    });
}


function formatText(text) {
    console.log("Original text:", text); // Log original text for debugging

    // Handle <bold> and <big> custom tags
    text = text
        .replace(/<bold>(.*?)<\/bold>/g, '<span class="bold-text">$1</span>')
        .replace(/<big>(.*?)<\/big>/g, '<span class="big-text">$1</span>')
        .replace(/<bold,\s?big>(.*?)<\/bold,\s?\/big>/g, '<span class="bold-big-text">$1</span>');

    // Ensure the closing tags are properly applied for <bold, big>
    text = text.replace(/<\/bold,\s?\/big>/g, '</span>');

    // Handle <problem> tag (if it needs to be removed or styled differently)
    text = text.replace(/<problem>/g, '').replace(/<\/problem>/g, '');

    // Keep (A), (B), (C), and (Z) intact by NOT modifying anything inside parentheses
    text = text.replace(/-\s([A-Z]\))\s+/g, function(match, p1) {
        return `<span class="bold-text">${p1.trim()}</span>`;
    });

    console.log("After replacing custom tags:", text); // Log the text after replacing custom tags

    return text;
}


function getAudioContext() {
    if (!audioContext) {
        audioContext = new (window.AudioContext || window.webkitAudioContext)();
    }
    return audioContext;
}

export async function playSound(filename, gainValue = 1.25) {
    const context = getAudioContext();

    try {
        const response = await fetch(`/static/${filename}.mp4`);
        const arrayBuffer = await response.arrayBuffer();
        const audioBuffer = await context.decodeAudioData(arrayBuffer);

        // ✅ Wait if paused BEFORE Promise
        await waitUntilResumed();

        return new Promise((resolve, reject) => {
            const source = context.createBufferSource();
            source.buffer = audioBuffer;

            const gainNode = context.createGain();
            gainNode.gain.value = gainValue;

            source.connect(gainNode).connect(context.destination);

            soundStatus.isPlaying = true;

            source.onended = () => {
                soundStatus.isPlaying = false;
                console.log(`✅ Sound ${filename} finished playing.`);
                resolve();
            };

            // ✅ Run async playback logic safely
            (async () => {
                try {
                    // Double-check pause state before playback
                    console.log("⏳ Waiting to begin speech/audio playback...");
                    await waitUntilResumed();
                    soundStatus.isPlaying = true;  // ✅ Set right before actual start
                    source.start(0);
                    console.log(`▶️ Sound ${filename} started with gain ${gainValue}.`);
                } catch (err) {
                    console.error(`❌ Error during sound playback start: ${err.message}`);
                    soundStatus.isPlaying = false;
                    reject(err);
                }
            })();
        });
    } catch (error) {
        console.error(`❌ Error playing sound ${filename}:`, error);
        soundStatus.isPlaying = false;
        return Promise.resolve(); // fallback so the app keeps going
    }
}


async function displayGoodbyeInstructions(segmentedInstructions) {
    console.log("Show Segmented Good Bye Instructions:", segmentedInstructions);
    const instructionsDiv = document.getElementById('instructions');
    instructionsDiv.innerHTML = ''; // Clear previous instructions

    for (const segment of segmentedInstructions) {
        if (segment.type === "sound") {
            // Play sound and wait for it to finish
            const soundFile = segment.value;
            console.log("Playing sound file:", soundFile);
            await playSound(soundFile); // Wait until sound completes
        } else if (segment.type === "text") {
            // Split the text segment into lines based on line breaks
            const lines = segment.value.split('\n');

            for (const line of lines) {
                if (line.trim() === '') continue; // Skip empty lines

                // Display the line
                const goodbyeParagraph = document.createElement('p');
                goodbyeParagraph.id = 'goodbyeParagraph';
                instructionsDiv.appendChild(goodbyeParagraph);
                await typeText(goodbyeParagraph, line.trim(), 10);  // Display line gradually
                goodbyeParagraph.style.display = 'flex';
                // Log and wait for speech synthesis of this line to finish
                // console.log("Speaking line:", line.trim());  // Debugging line
                await speakTextUnified(line.trim());
            }
        }
    }

    // Call showFeedbackAndQuestions once all segments are processed
    // showFeedbackAndQuestions();
}

async function displayInstructions(segmentedInstructions) {
    console.log("Show Segmented Instructions:", segmentedInstructions);
    const instructionsDiv = document.getElementById('instructions');
    const pauseButton = document.getElementById('pauseButton');

    // Show the pause button when the loop starts
    if (pauseButton) pauseButton.style.display = 'block';

    instructionsDiv.innerHTML = ''; // Clear previous instructions

    for (const segment of segmentedInstructions) {
        if (segment.type === "sound") {
            const soundFile = segment.value;
            console.log("Playing sound file:", soundFile);
            await playSound(soundFile, 3.5); // Wait until sound completes
        } else if (segment.type === "text") {
            const lines = segment.value.split('\n');

            for (const line of lines) {
                if (line.trim() === '') continue; // Skip empty lines

                while (isPaused) {
                    console.log("Paused... waiting to continue.");
                    await new Promise(resolve => setTimeout(resolve, 100)); // Wait while paused
                }

                const waitMatch = line.match(/<wait:(\d+)>/);
                if (waitMatch) {
                    const waitTime = parseInt(waitMatch[1], 10);
                    console.log(`Waiting for ${waitTime} milliseconds...`);
                    await new Promise(resolve => setTimeout(resolve, waitTime));
                    continue;
                }

                const paragraph = document.createElement('p');
                instructionsDiv.appendChild(paragraph);
                scrollInstructionsBoxToBottom();
                await typeText(paragraph, line.trim(), 10); // Display line gradually

                console.log("Speaking line:", line.trim());
                await speakTextUnified(line.trim());  // Speak the line
            }
        }
    }


    if (pauseButton) {
        if (!playbackControl.shouldStop) {
            pauseButton.style.display = 'none';
        } else {
            pauseButton.textContent = "Paused, press to Continue";
            pauseButton.classList.remove('yellow');
            pauseButton.classList.add('red');
            pauseButton.style.display = 'block';
            console.log("🔁 Preserving Continue button due to paused state.");
        }
    }

    // Note: We no longer call showFeedbackAndQuestions here.
}


async function displayQuestions(questions) {
    const questionContainer = document.getElementById('questions');
    console.log('call displayQuestions with questionContainer:', questionContainer);
    questionContainer.innerHTML = ''; // Clear previous questions

    const form = document.createElement('form');
    form.style.flexDirection = 'column';

    let aiTriggered = false; // Track if the AI-triggering question is present

    questions.forEach((question, index) => {
        const label = document.createElement('label');
        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = 'choice';
        radio.value = question.choice;

        const cleanText = question.text.replace(/\([A-Z]\)\s*/, ''); // Clean up choice text
        label.innerHTML = cleanText;
        label.prepend(radio);

        form.appendChild(label);

        // Check if the question is a (Z)-triggered question
        if (question.text.includes("(Z)")) {
            aiTriggered = true;
            label.innerHTML += " (Requires AI input)";
            radio.addEventListener('change', () => {
                showOpenAIInputField(); // Trigger OpenAI input field
            });
        }

        if (index === 0) {
            radio.checked = true;
        }
    });

    // 🔸 Create and configure the Submit button
    const submitButton = document.createElement('button');
    submitButton.type = 'button';
    submitButton.id = 'submitButton';
    submitButton.innerText = 'Submit';
    submitButton.disabled = true; // Initially disabled
    submitButton.classList.add('disabled'); // For gray styling

    submitButton.onclick = function () {
        const selectedChoice = form.querySelector('input[name="choice"]:checked');
        if (selectedChoice) {
            if (aiTriggered && selectedChoice.value === "(Z)") {
                handleOpenAIInput();
            } else {
                console.log('Clearing Radio-Buttons after Submit, in case selectedChoice:', selectedChoice);
                clearFeedbackAndRadioButtons();
                console.log('call getNextPhase with selected choice:', selectedChoice.value);
                getNextPhase(selectedChoice.value);
            }
        } else {
            alert('Please select an option.');
        }
    };

    form.appendChild(submitButton);
    questionContainer.appendChild(form);

    // Show questions container
    showRadioButtons();

    // Ensure the AI input field is shown if (Z) question is selected by default
    if (aiTriggered) {
        showOpenAIInputField();
    }
}


// Function to display the OpenAI input box
function showOpenAIInputField() {
    const openAIInput = document.createElement('textarea');
    openAIInput.id = 'openAIInput';
    openAIInput.placeholder = 'Please provide your input for AI...';
    openAIInput.style.width = '100%';
    openAIInput.style.height = '100px';

    // Append the input field under the questions
    document.getElementById('questions').appendChild(openAIInput);
}

export function enableFeedbackButton() {
  const feedbackButton = document.getElementById('feedbackSubmit');
  feedbackButton.disabled = false;
  feedbackButton.classList.remove('disabled');
}

export function enableSubmitButton() {
    const submitButton = document.getElementById('submitButton');
    if (submitButton) {
        submitButton.disabled = false;
        submitButton.classList.remove('disabled');
        console.log("✅ Submit button enabled after speech.");
    }
}

async function handleOpenAIInput() {
    console.log("Start HandleOpenAIInput");
    const aiInput = document.getElementById('openAIInput');
    if (aiInput && aiInput.value.trim()) {
        console.log('Sending input to OpenAI:', aiInput.value);

        try {
            const response = await fetch('/api/openai', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ prompt: aiInput.value })
            });

            const data = await response.json();

            const recommendationElement = document.getElementById('recommendation');
            recommendationElement.innerText = data.output;

            console.log("Speaking OpenAI output:", data.output);
            await speakTextUnified(data.output); // Ensure AI output is spoken sequentially

            // Clear fields and move to the next phase
            console.log("Clearing Radio-Buttons after AI Output");
            clearFeedbackAndRadioButtons();
        } catch (error) {
            console.error('Error with OpenAI API:', error);
        }
    } else {
        alert('Please provide your input for AI.');
    }
}

    function hideRadioButtons() {
        document.getElementById('questions').style.display = 'none';
    }

    function showRadioButtons() {
        document.getElementById('questions').style.display = 'flex';
    }


// Existing helper function adjusted slightly
async function showFeedbackAndQuestions(phase) {
    const feedbackBox = document.getElementById('feedbackBox');
    feedbackBox.style.display = 'flex';

    const feedbackLabel = document.querySelector('label[for="feedbackInput"]');
    if (phase === 1) {
        // feedbackLabel.textContent = "How does this sound to you? Shall we start? You can also ask me any question about the process.";
        feedbackLabel.textContent = "How does this sound to you? Shall we start?";
    } else {
        feedbackLabel.textContent = "How did the last part of the session work for you?";
    }
    await speakTextUnified(feedbackLabel.textContent);

    if (isMobileDevice()) {
        showQuestionsBoxMobile();
    } else {
        // Desktop unchanged (existing logic)
        const questionsBox = document.getElementById('questionsBox');
        questionsBox.style.display = 'block';
    }

    setTimeout(() => {
        document.getElementById('feedbackInput').focus();
    }, 100);
}


async function showFeedbackAndQuestionsSafe(currentPhase) {
    if (playbackControl.shouldStop) {
        console.warn("⏸️ Paused — holding before showing feedback/questions...");
        await waitUntilResumed();
        console.log("▶️ Resumed — now showing feedback/questions.");
    }
    showFeedbackAndQuestions(currentPhase);
}


async function showFeedbackAndQuestionsZauber(phase) {
    console.log(`[${new Date().toISOString()}] showFeedbackAndQuestions called with phase: ${phase}`);

    // On mobile, reveal the questions overlay by adding the "show" class to #questionsBox.
    if (isMobileDevice()) {
        const questionsBox = document.getElementById('questionsBox');
        if (questionsBox) {
            questionsBox.classList.add('show');
        } else {
            console.warn("questionsBox element not found.");
        }
    }

    const feedbackBox = document.getElementById('feedbackBox');
    feedbackBox.style.display = 'flex'; // Ensure feedback box is visible

    const feedbackInput = document.getElementById('feedbackInput');
    const feedbackLabel = document.querySelector('label[for="feedbackInput"]');

    // Set feedback label based on phase
    if (phase === 1) {
        feedbackLabel.textContent = "How does this sound to you? Shall we start? You can also ask me any question about the process.";
        await speakTextUnified(feedbackLabel.textContent);
    } else {
        feedbackLabel.textContent = "How did the last part of the session work for you?";
        await speakTextUnified(feedbackLabel.textContent);
    }

    // Focus on the feedback input after a slight delay
    setTimeout(() => {
        feedbackInput.focus();
        console.log(`[${new Date().toISOString()}] Attempting to focus feedback input`);
    }, 100);
}

async function getNextPhase(choice = "A") {
    await waitUntilResumed(); // ⬅️ Top-level check, synchronous guarantee

    try {
        clearFeedbackAndRecommendation();
        enableFeedbackButton();

        const response = await fetch('/next-phase', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ choice: choice })
        });

        if (!response.ok) throw new Error('Bad Request: ' + response.statusText);

        const data = await response.json();
        activatePhase(data.phase - 1);

        if (!data.is_last_phase) {
            await displayInstructions(data.segmentedInstructions, data.soundFiles);
            await displayQuestions(data.questions || []);
            hideRadioButtons();

            if (playbackControl.shouldStop) {
                console.warn("⏸️ Paused — holding before showing questions box...");
                await waitUntilResumed();
                console.log("▶️ Resumed — now showing questions box.");
            }

            if (isMobileDevice()) {
                showQuestionsBoxMobile();
            } else {
                questionsBox.style.display = 'block';
            }


            await showFeedbackAndQuestionsSafe(data.phase);

        } else {
            await displayGoodbyeInstructions(data.segmentedInstructions || 'No instructions received', data.soundFiles || []);
            document.getElementById('feedbackBox').style.display = 'none';
        }

    } catch (error) {
        console.error("Error fetching the next phase:", error);
    }
}


async function getNextPhaseZauber(choice = "A") {
    try {

        // Hide the old questions box if we’re on mobile
        if (isMobileDevice()) {
            hideQuestionsBoxMobile();
        }

        clearFeedbackAndRecommendation(); // Clear previous feedback and recommendation

        const response = await fetch('/next-phase', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ choice: choice })
        });

        if (!response.ok) {
            throw new Error('Bad Request: ' + response.statusText);
        }

        const data = await response.json();
        console.log('Phase received:', data.phase);
        console.log('Instructions received:', data.segmentedInstructions);

        // Highlight the active phase using data.phase
        activatePhase(data.phase - 1);

        if (! data.is_last_phase) {
            await displayInstructions(data.segmentedInstructions || 'No instructions received', data.soundFiles || []);
            // speakTextAfterVoicesLoaded(data.segmentedInstructions || 'No instructions received');
            await displayQuestions(data.questions || []);
            // Hide radio buttons
            hideRadioButtons();

            // Show feedback box and update label based on phase
            console.log("Calling showFeedbackAndQuestions:", data.phase);
            showFeedbackAndQuestions(data.phase);  // Pass the current phase to the function

            } else {
              await displayGoodbyeInstructions(data.segmentedInstructions || 'No instructions received', data.soundFiles || []);
              //speakTextAfterVoicesLoaded(data.segmentedInstructions || 'No instructions received');
              feedbackBox.style.display = 'none';  // Do not show feedback box
              // await displayQuestions(data.questions || []);
            }

    } catch (error) {
        console.error("Error fetching the next phase:", error);
    }
}

    async function resetPhase() {
        try {
            const response = await fetch('/reset-phase', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            if (!response.ok) {
                throw new Error('Failed to reset phase: ' + response.statusText);
            }

            const data = await response.json();
            console.log(data.message);
        } catch (error) {
            console.error("Error resetting phase:", error);
        }
    }

function showGoodbyeMessage(goodbyeText) {
    // Clear all dynamic content from the content area
    const contentArea = document.getElementById('contentArea');
    contentArea.innerHTML = ''; // Clear all previous content

    // Create the goodbye message element
    const goodbyeMessage = document.createElement('div');
    goodbyeMessage.id = 'goodbyeMessage';
    goodbyeMessage.textContent = goodbyeText; // Set the text from the last phase

    // Append the goodbye message to the content area
    contentArea.appendChild(goodbyeMessage);

    // Apply the display style to show the goodbye message
    goodbyeMessage.style.display = 'flex';
}

async function handleEndOfProcess() {
    try {
        // Fetch the instructions for the last phase
        const response = await fetch('/next-phase', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ choice: "A" }) // Adjust as necessary to indicate the end phase
        });

        if (!response.ok) {
            throw new Error('Failed to fetch the last phase: ' + response.statusText);
        }

        const data = await response.json();
        const goodbyeInstructions = data.instructions || "Thank you for participating."; // Default if no instructions

        // Display the goodbye message with the last phase's instructions
        showGoodbyeMessage(goodbyeInstructions);
    } catch (error) {
        console.error("Error handling the end of the process:", error);
    }
}

document.addEventListener("DOMContentLoaded", function () {
  const mobileOverlay = document.getElementById("mobileOverlay");
  const introImage = document.querySelector(".intro-image");
  const overlayText = document.querySelector(".overlay-text");

  // Log initial inline styles
  console.log("Initial inline style - display:", mobileOverlay.style.display);
  console.log("Initial inline style - opacity:", mobileOverlay.style.opacity);

  const computed = window.getComputedStyle(mobileOverlay);
  console.log("Initial computed style - display:", computed.display);
  console.log("Initial computed style - opacity:", computed.opacity);

  if (window.innerWidth <= 768) {
    console.log("Mobile detected, starting overlay sequence.");

    // Reset inline styles
    mobileOverlay.style.display = "";
    mobileOverlay.style.opacity = "";
    console.log("Cleared inline styles.");

    // Add show class
    mobileOverlay.classList.add("show");
    console.log("Added .show class to #mobileOverlay.");

    // Log after adding .show
    const updated = window.getComputedStyle(mobileOverlay);
    console.log("After .show - computed display:", updated.display);
    console.log("After .show - computed opacity:", updated.opacity);

    // Step 1: Fade in image
    setTimeout(() => {
      console.log("Fade in image.");
      introImage.classList.add("fade-in");
    }, 100);

    // Step 2: Fade in text
    setTimeout(() => {
      console.log("Fade in text.");
      overlayText.classList.add("fade-in");
    }, 600);

    // Step 3: Hold and fade out
    setTimeout(() => {
      console.log("Start fade out.");
      introImage.classList.add("fade-out");
      overlayText.classList.add("fade-out");

      // Step 4: Hide overlay
      setTimeout(() => {
        console.log("Hiding overlay completely.");
        mobileOverlay.style.display = "none";
      }, 500);
    }, 600 + 500 + 3000);
  } else {
    console.log("Not mobile, skipping overlay.");
  }
});


    document.addEventListener('DOMContentLoaded', function() {


        document.getElementById('button-start').addEventListener('click', async function() {

            initializeAudioContext(); // Unlock AudioContext inside user interaction
            unlockAudio(); // Play silent audio inside user gesture

            await resetPhase();

            document.getElementById('button-start').style.display = 'none';
            hideRadioButtons();
            getNextPhase();

            // Add border to instructions box
            document.querySelector(".instructions-box").classList.add("border-active");

        });

       document.getElementById('feedbackSubmit').addEventListener('click', async function() {
            const feedbackButton = this;
            const feedbackText = document.getElementById('feedbackInput').value;
            if (feedbackText.trim()) {
                feedbackButton.disabled = true;
                feedbackButton.classList.add('disabled');
                const response = await fetch('/feedback', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ feedback: feedbackText })
                });

                const data = await response.json();

                const recommendationElement = document.getElementById('recommendation');
                recommendationElement.innerText = data.recommendation;

                // ✅ Show questions right away
                showRadioButtons();

                // ✅ Disable the submit button before speaking
                const submitButton = document.getElementById('submitButton');
                if (submitButton) {
                    submitButton.disabled = true;
                    submitButton.classList.add('disabled');
                }

                // ✅ Let browser render the UI before starting speech
                await new Promise(requestAnimationFrame);

                // ✅ Speak the recommendation
                console.log("🔊 Speaking recommendation:", data.recommendation);
                await speakTextUnified(data.recommendation);

                // ✅ Re-enable the submit button after speech
                if (submitButton) {
                    submitButton.disabled = false;
                    submitButton.classList.remove('disabled');
                    console.log("✅ Submit button enabled after speech.");
                }

            } else {
                alert("Please enter your feedback.");
            }
        }); 
       
    });


document.addEventListener("DOMContentLoaded", function () {
    const label = document.querySelector('label[for="feedbackInput"]');

    if (!label) return; // Exit if label not found

    let sentences = label.innerHTML.split(/(?<=\.) /); // Split sentences by ". "
    label.innerHTML = sentences.map(sentence => `<span class="sentence">${sentence}</span>`).join(" ");
    let sentenceElements = document.querySelectorAll('label[for="feedbackInput"] .sentence');

    function isElementVisible(el) {
        const style = window.getComputedStyle(el);
        return style.display !== "none" && style.visibility !== "hidden" && parseFloat(style.opacity) > 0;
    }

    function highlightSentences() {
        let index = 0;
        function highlightNextSentence() {
            if (index > 0) {
                sentenceElements[index - 1].classList.remove("highlight");
            }
            if (index < sentenceElements.length) {
                sentenceElements[index].classList.add("highlight");
                index++;
                setTimeout(highlightNextSentence, 1000); // Highlight each for 1 second
            }
        }
        highlightNextSentence();
    }

    // Observer for detecting when the label becomes visible
    const observer = new MutationObserver((mutationsList, observer) => {
        console.log("Mutation detected:", mutationsList);
    
        if (isElementVisible(label)) {
           console.log("Label is now visible, starting highlight...");
           highlightSentences();
           observer.disconnect(); // Stop observing after execution
        }
    });


    observer.observe(label, { attributes: true, attributeFilter: ["style", "class"] });
});



// Toggle pause state on button click
document.addEventListener('DOMContentLoaded', () => {
    const pauseButton = document.getElementById('pauseButton');
    if (!pauseButton) {
        console.error("Pause button not found in the DOM.");
        return;
    }

        pauseButton.addEventListener('click', () => {
            if (!isPaused) {
                // ✅ Step 1: User pressed PAUSE
                isPaused = true;
                playbackControl.shouldStop = true;

                pauseButton.textContent = "Pausing...";
                pauseButton.classList.remove('blue');
                pauseButton.classList.add('yellow');
                console.log("⏸️ Pause initiated. Waiting for current speech/sound to finish...");

                // ✅ Step 2: Immediately transition if nothing is playing
                if (!speechStatus.isSpeaking && !soundStatus.isPlaying) {
                    // Also check if we're preventing future playback
                    const checkIfNothingWillPlay = true;  // can add logic if needed
                    if (checkIfNothingWillPlay) {
                        pauseButton.textContent = "Paused, press to Continue";
                        pauseButton.classList.remove('yellow');
                        pauseButton.classList.add('red');
                        console.log("🛑 Nothing playing or scheduled. Pause ready immediately.");
                        return;
                    }
                }

                // ✅ Step 3: Wait if something is currently playing
                const interval = setInterval(() => {
                    if (!speechStatus.isSpeaking && !soundStatus.isPlaying) {
                        clearInterval(interval);
                        pauseButton.textContent = "Paused, press to Continue";
                        pauseButton.classList.remove('yellow');
                        pauseButton.classList.add('red');
                        console.log("🛑 Playback stopped. Ready to continue.");
                    }
                }, 200);
            } else {
                // ✅ Step 4: User pressed CONTINUE
                isPaused = false;
                playbackControl.shouldStop = false;

                pauseButton.textContent = "Pause";
                pauseButton.classList.remove('red');
                pauseButton.classList.add('blue');
                console.log("▶️ Resumed — playback allowed.");
            }
        });

});

document.addEventListener('DOMContentLoaded', function() {
    const phaseToggle = document.getElementById('phaseToggle');
    const phaseOverlay = document.getElementById('phaseOverlay');
    const closePhase = document.getElementById('closePhase');
    const phaseList = document.getElementById('phaseList');
    const phaseColumn = document.getElementById('phaseColumn');

    // Phase titles
    const phases = [
        "INTRODUCTION", "FLOW RHYTHM", "RESOURCE STATE I", "DECOMPRESSION RHYTHM",
        "RESOURCE STATE II", "FREEZING", "DECOMPRESSION PROCESS", "RESOURCE STATE II",
        "RESOURCE RHYTHM", "RESOURCE STATE I", "RESOURCE STATE II", "RESOURCE-RHYTHM AND REENTERING INTO HERE AND NOW",
        "CLOSING STATEMENT", "CONCLUSION"
    ];

    // Function to populate phase rows for BOTH desktop and overlay
    function populatePhaseLists() {
        phaseColumn.innerHTML = ''; // Clear desktop list
        phaseList.innerHTML = ''; // Clear overlay list

        phases.forEach((phase, index) => {
            // Create desktop phase row
            const desktopRow = document.createElement('div');
            desktopRow.classList.add('phase-row');
            desktopRow.textContent = phase;
            desktopRow.dataset.phaseIndex = index;
            phaseColumn.appendChild(desktopRow);

            // Create overlay phase row (pre-created but hidden)
            const overlayRow = document.createElement('div');
            overlayRow.classList.add('phase-row');
            overlayRow.textContent = phase;
            overlayRow.dataset.phaseIndex = index;
            phaseList.appendChild(overlayRow);
        });

        console.log("✅ Phase lists populated for desktop and overlay");
    }

    // Populate the phase lists on page load
    populatePhaseLists();

    // Open overlay when clicking 'Show Phase Guide'
    phaseToggle.addEventListener('click', function() {
        phaseOverlay.classList.add('active'); // Show overlay

        // Ensure the correct phase is highlighted
        const currentPhaseIndex = getCurrentPhaseIndex(); // Function to get current phase
        activatePhase(currentPhaseIndex);
    });

    // Close overlay when clicking '×'
    closePhase.addEventListener('click', function() {
        phaseOverlay.classList.remove('active'); // Hide overlay
    });
});

// Debug: Expose repaint function to console
window.debugForceRepaint = function () {
  const selectors = [
    '#submitButton',
    '.close-phase-overlay',
    '.masonry-container',
    '.masonry-item',
  ];

  const elements = document.querySelectorAll(selectors.join(', '));

  elements.forEach((el, i) => {
    el.style.transform = 'scale(1)';
    el.style.willChange = 'transform';
    console.log(`🔁 Repainted [${i + 1}/${elements.length}]`, el);
  });

  console.log(`✅ debugForceRepaint() executed for ${elements.length} elements`);
};

// Debug: Expose width overflow logger to console
window.debugLogOversizedElements = function () {
  const vpWidth = window.visualViewport?.width || window.innerWidth;
  const oversized = [];

  document.querySelectorAll('*').forEach(el => {
    const rect = el.getBoundingClientRect();
    if (rect.width > vpWidth + 1) {
      oversized.push({
        tag: el.tagName,
        id: el.id,
        className: el.className,
        actualWidth: rect.width,
        vpWidth: vpWidth
      });
    }
  });

  console.log(`🔎 Found ${oversized.length} elements wider than visual viewport (${vpWidth}px):`);
  console.table(oversized);
};
